import React, { useRef, useEffect } from "react";

// Componente para Desktop
function VideoDesktop() {
  const videoRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;
    if (video) {
      video.playbackRate = 3;

      const handleVideoEnd = () => {
        video.pause();
      };

      video.addEventListener('ended', handleVideoEnd);

      return () => {
        video.removeEventListener('ended', handleVideoEnd);
      };
    }
  }, []);

  return (
    <div className="hidden md:block" style={{ 
      position: 'relative',
      width: '100vw',
      marginLeft: 'calc(50% - 50vw)',
      marginRight: 'calc(50% - 50vw)'
    }}>
      <video
        ref={videoRef}
        autoPlay
        muted
        playsInline
        style={{ 
          width: '100%', 
          height: '60vh',
          objectFit: 'cover',
          display: 'block'
        }}
      >
        <source src="/videos/Huemul 1.mp4" type="video/mp4" />
        Tu navegador no soporta videos HTML5.
      </video>
    </div>
  );
}

// Componente para Móvil
function VideoMobile() {
  const videoRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;
    if (video) {
      video.playbackRate = 3;

      const handleVideoEnd = () => {
        video.pause();
      };

      video.addEventListener('ended', handleVideoEnd);

      return () => {
        video.removeEventListener('ended', handleVideoEnd);
      };
    }
  }, []);

  return (
    <div className="block md:hidden" style={{ 
      position: 'relative',
      width: '100vw',
      marginLeft: 'calc(50% - 50vw)',
      marginRight: 'calc(50% - 50vw)'
    }}>
      <video
        ref={videoRef}
        autoPlay
        muted
        playsInline
        className="w-full h-48"
        style={{ 
          objectFit: 'cover',
          display: 'block'
        }}
      >
        <source src="/videos/Huemul 1.mp4" type="video/mp4" />
        Tu navegador no soporta videos HTML5.
      </video>
    </div>
  );
}

export default function VideoSection() {
  return (
    <>
      <VideoDesktop />
      <VideoMobile />
    </>
  );
} 